import { LocationInput } from '@kinetic-ui/data-layer';
import { LocationFormValues, LocationType } from '../types';

import { EditLocation } from './formToInput';
import { trimGraphqlType } from 'kineticUtils/data/trimGraphqlType';

export const LocationInputToForm = (location: EditLocation | LocationInput): LocationFormValues => {
  const id = location.id ? location.id : undefined;
  const formValues: LocationFormValues = {
    id: id,
    name: location.details.name,
    description: location.details.description ?? undefined,
    locationType: location.locationType as LocationType,
    geometry: location.geometry,
    crosswalks: trimGraphqlType(location.crosswalks),
    maneuvers: trimGraphqlType(location.maneuvers),
    lanes: trimGraphqlType(location.lanes),
    color: location.color ?? undefined,
    opacity: location.opacity ?? undefined,
  };
  return formValues;
};
